import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import CommentBox from '../../../CommentBox';
import { withCommentContext, } from '../CommentContext/CommentContext';
import CommentHeader from '../CommentHeader';
import CommentFooter from '../CommentFooter';
import CommentBody from '../CommentBody';
import s from '../../Comment.scss';
import threadStyles from '../../../CommentThread/CommentThread.scss';
var CommentContent = /** @class */ (function (_super) {
    __extends(CommentContent, _super);
    function CommentContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCloseEditor = function () {
            var setEditingState = _this.props.setEditingState;
            setEditingState('none');
        };
        _this.hideActionMenu = function () {
            var setActionMenuOpen = _this.props.setActionMenuOpen;
            setActionMenuOpen(false);
        };
        _this.onEditDone = function (result) {
            var _a = _this.props, setEditingState = _a.setEditingState, onCommentUpdated = _a.onCommentUpdated;
            setEditingState('none');
            onCommentUpdated && result.comment && onCommentUpdated(result);
        };
        return _this;
    }
    CommentContent.prototype.render = function () {
        var _a = this.props, comment = _a.comment, className = _a.className, bodyClassName = _a.bodyClassName, footerClassName = _a.footerClassName, showAvatar = _a.showAvatar, isEditing = _a.isEditing, showActions = _a.showActions, showAuthorInfo = _a.showAuthorInfo, showFooter = _a.showFooter, showBasicFooter = _a.showBasicFooter, indent = _a.indent, compact = _a.compact, onReplyPosted = _a.onReplyPosted, canPostComment = _a.canPostComment;
        if (isEditing) {
            return this.renderEditor(comment);
        }
        return (React.createElement(CommentBody, { className: classnames(s['container'], !showAvatar && s['no-avatar'], className), bodyClassName: bodyClassName, header: React.createElement(CommentHeader, { showActions: showActions, showAuthorInfo: showAuthorInfo, showAvatar: showAvatar }), footer: showFooter && (React.createElement(CommentFooter, { className: footerClassName, showBasicFooter: showBasicFooter, indent: indent, onReplyPosted: onReplyPosted, canPostComment: canPostComment, compact: compact })), onMouseLeave: this.hideActionMenu }));
    };
    CommentContent.prototype.renderEditor = function (comment) {
        var _a = this.props, currentUser = _a.currentUser, canPostComment = _a.canPostComment, indent = _a.indent, compact = _a.compact;
        return (React.createElement("div", { className: s['comment-editor'] },
            React.createElement(CommentBox, { className: threadStyles["reply-outdent-" + indent], onPublishSuccess: this.onEditDone, id: "edit-" + comment.commentId, commentableType: comment.typeId, commentableItemId: comment.itemId, user: currentUser, editComment: comment, autoFocus: true, onClose: this.onCloseEditor, canPostComment: canPostComment, compact: compact })));
    };
    return CommentContent;
}(React.Component));
export default withCommentContext(withTranslation()(CommentContent));
//# sourceMappingURL=CommentContent.js.map